// 手机号
export const rMobilePhone = /^1\d{10}$/

// 账号
export const rAccount = /^(\d|[a-zA-Z]){4,11}$/

// 密码 支持字母/数字/下划线(6-16)
export const rPassword = /^\w{6,16}$/

// 验证码
export const rVerCode = /^\d{4}$/
